import React, { useMemo, useEffect } from 'react';
import { Image } from '@hz-design-system/web-ui';
import { TMpCard } from 'homepage-web-bff/types/TMpCard';
import Classes from './MpCard.module.scss';
import { trackGAEvent } from '../../../../utils/gaTracking';
import { checkAndIncrementFrequencyCap } from './utils/frequencyCapping';

const MpCardBanner = ({ mpCards }: { mpCards: TMpCard[] }) => {
  const mpCardBanner = useMemo(() => {
    if (!mpCards?.length) return null;
    return mpCards.find((card) => card.id === 'mp-cards-homepage-top-banner') || null;
  }, [mpCards]);

  useEffect(() => {
    if (!mpCardBanner) return;

    // the server leaves out capped cards, so here we only count the view
    checkAndIncrementFrequencyCap(mpCardBanner.id, mpCardBanner.frequencyCap);
  }, [mpCardBanner]);

  if (!mpCardBanner) return null;

  const { imageAspectRatio } = mpCardBanner;

  const clickHandler = () => {
    if (mpCardBanner.trackingEventName) {
      trackGAEvent(mpCardBanner.trackingEventName, 'HPCards');
    }
    if (mpCardBanner.landingUrl) {
      window.location.href = mpCardBanner.landingUrl;
    }
  };

  return (
    <div
      className={Classes.mpCardBanner}
      // reserves the image height before it loads
      style={
        imageAspectRatio?.width && imageAspectRatio?.height
          ? { aspectRatio: `${imageAspectRatio.width} / ${imageAspectRatio.height}` }
          : undefined
      }
      onClick={clickHandler}
      onKeyDown={(e) => e.key === 'Enter' && clickHandler()}
      role="button"
      tabIndex={0}
    >
      <Image src={mpCardBanner.imageUrl} alt="Marktplaats Marketing Banner" loading="eager" decoding="sync" />
    </div>
  );
};

export default React.memo(MpCardBanner);
